import React from 'react'

function Icon({width , height}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={`${width}px`} height={`${height}px`} viewBox={`"0 0 ${width} ${height}"`}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-215.000000, -237.000000)">
          <g transform="translate(215.000000, 237.000000)">
            <path d="M3.80997512,0 L37.7900249,0 C38.8945944,4.16540226e-15 39.7900249,0.8954305 39.7900249,2 C39.7900249,2.06645952 39.7867122,2.13287774 39.7800993,2.19900744 L38.1800993,18.1990074 C38.0778589,19.221411 37.2175278,20 36.1900249,20 L2.20997512,20 C1.10540562,20 0.209975124,19.1045695 0.209975124,18 C0.209975124,17.9335405 0.213287774,17.8671223 0.219900744,17.8009926 L1.81990074,1.80099256 C1.9221411,0.778588967 2.78247223,6.3283843e-16 3.80997512,0 Z" id="矩形" fill="#E34D59" />
            <text fontFamily="AlibabaPuHuiTi-Medium, Alibaba PuHuiTi" fontSize="12" fontWeight="400" fill="#FFFFFF">
              <tspan x="8" y="15">重要</tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  )
}

const ImportantIcon = (props) => {
  const { width, height } = props
  return (
    <Icon width={width} height={height} />
  )
}

// 默认参数
ImportantIcon.defaultProps = {
  width: 40,
  height: 20,
}
export default ImportantIcon
